import React, { PropsWithChildren } from 'react';
import styles from './SlideIn.module.scss';
import cn from 'classnames';

export interface SlideInProps {
  /** Animation delay in ms */
  delay?: number;
  /** Slide direction */
  direction?: 'left' | 'right' | 'up' | 'down';
  /** Animation duration in ms */
  duration?: number;
  /** How far past the target to overshoot (in pixels). Increases create slinky effect. */
  overshoot?: number;
  /** Additional CSS class */
  className?: string;
}

export default function SlideIn({
  children,
  delay = 0,
  direction = 'right',
  duration = 2000,
  overshoot = 15,
  className
}: PropsWithChildren<SlideInProps>) {
  // Calculate overshoot direction based on slide direction
  const overshootValue = (direction === 'right' || direction === 'down')
    ? -overshoot
    : overshoot;

  return (
    <div
      className={cn(styles.slideIn, styles[direction], className)}
      style={{
        '--slide-delay': `${delay}ms`,
        '--slide-duration': `${duration}ms`,
        '--slide-overshoot': `${overshootValue}px`,
        '--slide-bounce': `${-overshootValue / 3}px`
      } as React.CSSProperties}
    >
      {children}
    </div>
  );
}
